<template>

    <div class="border border-secondary bg-light filter">
        <div class="">
            <label class="filter__btn">
                <input type="checkbox" 
                       :id="id" 
                       class="me-2" 
                       :checked="checked" 
                       @change="$emit('change', $event.target.checked)" />
                {{ translatedLabel }}
            </label>
        </div>
    </div>

</template>

<script>
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';

    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `checkbox-input-${this._uid}`
                },
            },
            checked: Boolean,
            label: String,
        },
        model: {
            prop: 'checked',
            event: 'change'
        },
        components: {
            CheckboxInput,
        },
        data() {
            return {
//                supplier: null,
//                suppliers: [],
            }
        },
        mounted() {
//            axios.get(route('suppliers.index')).then((response) => {
//                console.log(response.data);
//                this.suppliers = response.data;
//            })
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
    }
</script>
